import { render, staticRenderFns } from "./ExpenseTable.vue?vue&type=template&id=6ad8aff9"
import script from "./ExpenseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports